import { useEffect, useState } from "react";
import api from "@/components/customAxios/Axios";
import { Link } from "react-router-dom";
import { GoDotFill } from "react-icons/go";
import useRelativeTime from "@/hooks/useRelativeTime";
import { useToast } from "@/components/toast";
// import { FiSearch } from "react-icons/fi";
const ApplicantsQuickTable = () => {
	const [applicants, setApplicants] = useState([]);
	const toast = useToast();
	const getApplicants = async () => {
		try {
			const user_id = localStorage.getItem("user");
			const response = await api.get("/user_applicants_list", {
				params: {
					user_id,
					quick_data: true,
				},
			});
			if (response.status === 200) {
				setApplicants(response.data.data);
			}
		} catch (error: any) {
			toast.error({
				type: "background",
				duration: 3000,
				status: "error",
				title: "Error",
				description: error.response?.data?.error || error.response?.data?.message || "Failed to fetch applicants",
				open: true,
			});
		}
	};
	useEffect(() => {
		getApplicants();
	}, []);
	return (
		<div className=" mt-3 bg-white rounded-lg p-3 ">
			<div className="flex justify-between gap-x-1 items-center  font-body">
				<h2 className="mr-5 font-bold text-lg">Applicants</h2>
				<Link to="/applicants" className="text-gray-500 hover:underline">
					View All
				</Link>
			</div>
			{/* user log table */}
			<div className=" overflow-x-auto mt-3">
				<div className="max-h-[550px] min-h-[550px] overflow-y-auto p-2">
					{applicants.map((elem: any) => {
						return (
							<div className="flex items-center justify-between p-4 ">
								{/* Left Section */}
								<div className="flex items-center gap-4">
									{/* Circle with Initials */}
									<div className="w-10 h-10 flex items-center justify-center rounded-full bg-gray-200 text-gray-600 font-semibold">
										{elem.name[0].toUpperCase() + elem.name[1].toUpperCase()}
									</div>

									{/* Name and Status */}
									<div>
										<div className="flex items-center gap-3 flex-wrap">

											<div className="font-medium text-gray-900">{elem.name}</div>
											<div className="text-sm text-gray-400">
												{useRelativeTime(elem.created_at)}
											</div>
										</div>
										<div className="flex items-center text-sm text-gray-500 gap-8">
											<div
												className={`flex items-center   ${elem.status?.includes(
													"Assessment link send to candidate"
												)
													? "text-[#8183D6]"
													: elem.status?.includes("Assessment completed")
														? "text-[#2B9870]"
														: elem.status?.includes("Terminated")
															? "text-red-500"
															: "text-[#FFC452]"
													}`}
											>
												<GoDotFill />
												<span className="ml-1 ">
													{elem.status?.includes(
														"Assessment link send to candidate"
													)
														? "Assessment Link Sent to Candidate"
														: elem.status?.includes("Assessment completed")
															? "Assessment Completed"
															: elem.status?.includes("Terminated")
																? "Terminated"
																: "Assessment Not Sent"}
												</span>
											</div>

											{/* <span className="flex items-center gap-1">
												<span className="w-2 h-2 bg-blue-500 rounded-full"></span>{" "}
												New
											</span>
											<span>•</span>
											<span>Match: 83%</span> */}
										</div>

									</div>
								</div>

								{/* Date */}

							</div>
						);
					})}

					{/* <table className="w-full  text-sm ">
						<thead className="bg-white p-2 font-subheading sticky top-0 text-gray-500">
							<tr>
								<th className="p-3 text-left ">Name</th>
								<th className="p-3 text-left ">Role</th>
								{/* <th>fs</th> */}
					{/* </tr>
						</thead>
						{applicants.length > 0 ? (
							<>
								<tbody className="font-body">
									{applicants.map((user: any) => (
										<tr
											key={user.candidate_id}
											className="border-b border-gray-300 hover:bg-slate-100"
										>
											{/* User Column */}
					{/* <td className="p-3 font-medium text-[#438437]"> */}
					{/* {user.name} */}
					{/* {user.email} */}
					{/* <UserLogsModal
											userName={user.user_name}
											userEmail={user.user_email}
										></UserLogsModal> */}
					{/* </td> */}
					{/* Other Columns */}
					{/* <td className="p-3 text-gray-700">{user.jds_created}</td> */}
					{/* <td className="p-3 text-gray-700">{user.job_name}</td>
											<td className="p-3 text-gray-700"> */}
					{/* <CandidateDetailsModal
													candidateId={user.candidate_id}
													candidateName={user.name}
												></CandidateDetailsModal> */}
					{/* </td>
										</tr>
									))}
								</tbody> */}

					{/* <tfoot className="sticky bottom-0 bg-gray-100  font-subheading ">
										<Pagination
											dataLength={userLogs.length}
											currentPage={currentPage}
											handlePageClick={handlePageClick}
											totalItems={totalItems}
											totalPages={totalPages}
										/>
									</tfoot> */}
					{/* </>
						) : (
							<tbody>
								<tr>
									<td
										colSpan={6}
										className="p-3 text-center font-semibold text-2xl text-gray-500"
									>
										No Data Found
									</td>
								</tr>
							</tbody>
						)} */}
					{/* </table>  */}
				</div>
			</div>
		</div>
	);
};

export default ApplicantsQuickTable;
